import script from "./AccommodationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccommodationPage.vue?vue&type=script&setup=true&lang=ts"

import "./AccommodationPage.vue?vue&type=style&index=0&id=6460d69b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6460d69b"]])

export default __exports__